export class LocalStorageItem {
  key: string;
  value: string;
}
